import { Col } from 'components/Col';
import { CustomCheckbox } from 'components/CustomCheckbox';
import { HelpButton } from 'components/HelpButton';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { ChangeEvent, useContext } from 'react';
import languageValues from 'utils/LanguageUtils';

export default function DireitoImagem() {
  const { state, dispatch } = useContext(ProjetosContext);

  return (
    <Col cols={[12, 12, 12, 12, 12]}>
      <CustomCheckbox
        name='direitoImagem'
        label={languageValues.inputs.direitoImagem.label}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          dispatch({
            type: 'setProjeto',
            payload: {
              direitoImagem: event.target.checked,
              // Desativar Consulta pública quando direito de imagem está desabilitado
              consultaPublica: !event.target.checked
                ? false
                : state.projeto.consultaPublica,
            },
          });
        }}
        checked={state.projeto.direitoImagem || false}
        disabled={state.disabledFields}
      >
        <HelpButton text={languageValues.inputs.direitoImagem.hint} />
      </CustomCheckbox>
    </Col>
  );
}
